import { CssVarsThemeOptions } from "@mui/material/styles";
import {
  getFloatingPanelStyles,
  getGlassBackdropStyles
} from "@themes/compositions/glass";
import { getFloatingDrawerOffsets } from "@themes/utils/drawer";

type ThemeComponents = NonNullable<CssVarsThemeOptions["components"]>;

export const createOverlayOverrides = (): ThemeComponents => ({
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme }) => ({
        width: "100%",
        ...getFloatingPanelStyles(theme)
      }),
      root: ({ theme }) => ({
        "& .MuiModal-backdrop": getGlassBackdropStyles(theme)
      })
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: "0 24px 20px 24px"
      }
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: "20px 24px"
      }
    }
  },
  MuiDrawer: {
    styleOverrides: {
      paper: ({ ownerState, theme }) => {
        // Permanent / persistent drawers (e.g. the MainSidebar) are not modal
        // overlays and should keep their bespoke styling untouched.
        if (
          ownerState?.variant === "permanent" ||
          ownerState?.variant === "persistent"
        ) {
          return {};
        }
        return {
          ...getFloatingDrawerOffsets(ownerState?.anchor),
          ...getFloatingPanelStyles(theme)
        };
      },
      root: ({ ownerState, theme }) => {
        if (
          ownerState?.variant === "permanent" ||
          ownerState?.variant === "persistent"
        ) {
          return {};
        }
        return {
          "& .MuiModal-backdrop": getGlassBackdropStyles(theme)
        };
      }
    }
  },
  MuiMenu: {
    styleOverrides: {
      list: {
        padding: 8
      }
    }
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: ({ theme }) => ({
        backgroundColor: theme.vars.palette.grey[900],
        borderColor: theme.vars.palette.grey[900]
      })
    }
  }
});
